import { useState } from "react";
import axios from "axios";

const gold = "#c8a96e";

const GLOSSARY = [
  { term: "Domain Flipping", def: "شراء دومين بسعر منخفض وبيعه بسعر أعلى لتحقيق ربح." },
  { term: "Brandable Domain", def: "دومين ذو اسم مخترع وجذاب يصلح كعلامة تجارية مثل Canva أو Notion." },
  { term: "Exact Match Domain", def: "دومين يطابق كلمة بحث شائعة بالضبط مثل bestlaptops.com." },
  { term: "Geo Domain", def: "دومين يتضمن اسم مدينة أو منطقة جغرافية مثل dubaihotels.com." },
  { term: "TLD / Extension", def: "امتداد الدومين مثل .com أو .net وهو الجزء بعد النقطة." },
  { term: "Domain Auction", def: "مزاد علني لبيع الدومينات لأعلى مشترٍ عبر منصات مثل GoDaddy." },
  { term: "Aftermarket", def: "سوق إعادة بيع الدومينات المسجلة مسبقاً من قِبل أشخاص آخرين." },
  { term: "Appraisal", def: "تقييم قيمة الدومين المالية بناءً على عوامل كالطول والكلمات المفتاحية." },
  { term: "Domain Parking", def: "عرض إعلانات على صفحة الدومين لتحقيق دخل بسيط ريثما يُباع." },
  { term: "Trademark Risk", def: "خطر قانوني عند تسجيل دومين يشبه علامة تجارية محمية." },
  { term: "WHOIS", def: "قاعدة بيانات تحتوي معلومات مالك الدومين وتاريخ تسجيله." },
  { term: "NameBio", def: "موقع يسجل تاريخ مبيعات الدومينات الفعلية لتقدير الأسعار." },
  { term: "Outbound Sales", def: "التواصل المباشر مع مشترين محتملين لعرض دوماناتك." },
  { term: "Inbound Sales", def: "انتظار العروض الواردة من مشترين مهتمين بدوماناتك." },
  { term: "Aged Domain", def: "دومين قديم التسجيل مما يزيد قيمته SEO وجاذبيته للمشترين." },
  { term: "Drop Catching", def: "التقاط دومينات لحظة انتهاء صلاحيتها قبل أن يسجلها شخص آخر." },
];

const TIPS = [
  { title: "ابدأ بـ .com دائماً", body: "امتداد .com هو الأكثر ثقة والأعلى قيمة. تجنب الامتدادات الغريبة في البداية." },
  { title: "تجنب الواصلات والأرقام", body: "الدومينات ذات الشرطات (-) أو الأرقام أصعب تسويقاً وتُباع بأسعار أقل." },
  { title: "أقصر = أغلى", body: "الدومينات القصيرة (4-6 أحرف) نادرة وذات قيمة عالية. كلما قصر الاسم زادت قيمته." },
  { title: "تحقق من العلامات التجارية", body: "قبل أي تسجيل تحقق من USPTO أو WIPO لضمان عدم التعارض مع علامة محمية." },
  { title: "ادرس المبيعات السابقة", body: "موقع NameBio يعرض آلاف المبيعات الفعلية. ابحث فيه قبل أي قرار شراء." },
  { title: "الصبر أساس النجاح", body: "معظم الدومينات تستغرق 6-18 شهراً للبيع. لا تتسرع في تخفيض السعر مبكراً." },
  { title: "وزّع على منصات متعددة", body: "اعرض دوماناتك على Afternic وSedo وDan.com في نفس الوقت لزيادة فرص البيع." },
  { title: "سعّر بواقعية", body: "السعر المرتفع جداً يُبعد المشترين، والمنخفض جداً يُضيع فرصة الربح. ابحث في السوق أولاً." },
];

const PLATFORMS = [
  { name: "Namecheap", use: "تسجيل الدومينات بأسعار تنافسية", price: "~$9/سنة", link: "namecheap.com", color: "#e05b2d" },
  { name: "GoDaddy Auctions", use: "شراء وبيع في المزادات", price: "متغير", link: "auctions.godaddy.com", color: "#1bce6b" },
  { name: "Sedo", use: "بيع متخصص للدومينات", price: "عمولة 15%", link: "sedo.com", color: "#0066cc" },
  { name: "Afternic", use: "شبكة بيع واسعة النطاق", price: "عمولة 20%", link: "afternic.com", color: "#ff6900" },
  { name: "Dan.com", use: "بيع مباشر وآمن", price: "عمولة 9%", link: "dan.com", color: "#7c3aed" },
  { name: "NameBio", use: "بحث المبيعات السابقة", price: "مجاني", link: "namebio.com", color: "#0891b2" },
  { name: "NamePros", use: "مجتمع وتعلم وبيع", price: "مجاني", link: "namepros.com", color: "#dc2626" },
  { name: "Estibot", use: "تقييم تلقائي للدومينات", price: "مجاني/مدفوع", link: "estibot.com", color: "#059669" },
];

export default function Learn() {
  const [tab, setTab] = useState("glossary");
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function ask() {
    if (!question.trim()) return;
    setLoading(true);
    setAnswer("");
    setError("");
    try {
      const { data } = await axios.post("/api/ai/ask", { question });
      setAnswer(data.result);
    } catch (err) {
      setError(err.response?.data?.error || "حدث خطأ في الاتصال");
    }
    setLoading(false);
  }

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 6, marginBottom: 24 }}>
        {[["glossary","📖 المصطلحات"],["tips","💡 النصائح"],["platforms","🌐 المنصات"],["ask","❓ اسألني"]].map(([id,lbl]) => (
          <button key={id} onClick={() => setTab(id)}
            style={{ padding: "9px 4px", borderRadius: 8, border: `1px solid ${tab===id?gold:"rgba(255,255,255,0.08)"}`, background: tab===id?`${gold}15`:"transparent", color: tab===id?gold:"#555", cursor: "pointer", fontSize: 11, fontFamily: "inherit" }}>
            {lbl}
          </button>
        ))}
      </div>

      {tab === "glossary" && GLOSSARY.map((g) => (
        <div key={g.term} style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 10, padding: 14, marginBottom: 10 }}>
          <div style={{ color: gold, fontWeight: 700, fontSize: 13, marginBottom: 5, direction: "ltr", textAlign: "left" }}>{g.term}</div>
          <div style={{ color: "#999", fontSize: 13, lineHeight: 1.7 }}>{g.def}</div>
        </div>
      ))}

      {tab === "tips" && TIPS.map((t, i) => (
        <div key={i} style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 10, padding: 14, marginBottom: 10 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
            <span style={{ background: `${gold}25`, color: gold, borderRadius: 6, width: 26, height: 26, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, flexShrink: 0 }}>{i+1}</span>
            <span style={{ color: "#fff", fontWeight: 700, fontSize: 14 }}>{t.title}</span>
          </div>
          <div style={{ color: "#999", fontSize: 13, lineHeight: 1.7 }}>{t.body}</div>
        </div>
      ))}

      {tab === "platforms" && PLATFORMS.map((p) => (
        <div key={p.name} style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 10, padding: 14, marginBottom: 10 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
            <span style={{ color: "#fff", fontWeight: 700, fontSize: 14 }}>{p.name}</span>
            <span style={{ background: `${p.color}20`, color: p.color, borderRadius: 6, padding: "2px 10px", fontSize: 11 }}>{p.price}</span>
          </div>
          <div style={{ color: "#888", fontSize: 13, marginBottom: 10 }}>{p.use}</div>
          <a href={`https://${p.link}`} target="_blank" rel="noreferrer" style={{ color: p.color, fontSize: 12, textDecoration: "none" }}>↗ {p.link}</a>
        </div>
      ))}

      {tab === "ask" && (
        <div>
          <p style={{ color: "#666", fontSize: 13, marginBottom: 16 }}>لديك سؤال عن مجال الدومينات؟ اسألني وسأجيبك فوراً</p>
          <textarea value={question} onChange={(e) => setQuestion(e.target.value)}
            placeholder="اكتب سؤالك هنا..."
            style={{ width: "100%", boxSizing: "border-box", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 10, padding: "13px 16px", color: "#fff", fontSize: 14, outline: "none", resize: "vertical", minHeight: 110, marginBottom: 12, fontFamily: "inherit" }} />
          <button onClick={ask} disabled={loading}
            style={{ width: "100%", background: loading?"#333":gold, color: "#0f0d0a", border: "none", borderRadius: 10, padding: 14, fontWeight: 700, cursor: loading?"not-allowed":"pointer", fontSize: 14, fontFamily: "inherit" }}>
            {loading ? "جارٍ البحث عن إجابة..." : "اسأل ◎"}
          </button>
          {loading && <div style={{ textAlign: "center", padding: "30px 0" }}><div style={{ color: gold, fontSize: 28 }}>◎</div><div style={{ color: "#555", fontSize: 13, marginTop: 8 }}>جارٍ التفكير...</div></div>}
          {error && <div style={{ background: "rgba(196,124,124,0.1)", border: "1px solid rgba(196,124,124,0.3)", borderRadius: 10, padding: 14, color: "#c47c7c", fontSize: 13, marginTop: 16 }}>{error}</div>}
          {answer && (
            <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(200,169,110,0.2)", borderRadius: 14, padding: 20, marginTop: 16 }}>
              <div style={{ color: gold, fontSize: 11, letterSpacing: 2, marginBottom: 12 }}>الإجابة</div>
              <div style={{ color: "#ddd", fontSize: 14, lineHeight: 2, whiteSpace: "pre-wrap" }}>{answer}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
